import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FulfillService } from '../../fulfill.service';
import { PanelState } from '../../utils/models';
import { getOrderSplitIndicesString } from '@utils/order-split-utils';
import { getOrderExternalId } from '@utils/order.utils';
@Component({
  selector: 'fulfill-side-panel-order-header',
  templateUrl: './fulfill-side-panel-order-header.component.html',
  styleUrls: ['./fulfill-side-panel-order-header.component.scss'],
  standalone: false,
})
export class FulfillSidePanelOrderHeaderComponent implements OnInit, OnChanges {
  @Input() order;
  @Input() isPickAndPackFocus;
  @Input() printOptions = [];
  @Input() printSections = [];
  @Output() printOrder = new EventEmitter();
  batch;
  orderSplitIndices: string;
  fulfillService;
  eCommerceOrderExternalLink: string;

  constructor(fulfillService: FulfillService) {
    this.fulfillService = fulfillService;
  }

  ngOnInit(): void {
    this.batch = this.fulfillService.activeBatch;
    this.orderSplitIndices = getOrderSplitIndicesString(this.order, 'view');
    this.generateExternalEcommerceOrderLink(this.order);
  }

  generateExternalEcommerceOrderLink(order) {
    const platform = order.shop.platform == null ? 'shopify' : order.shop.platform;
    const externalId = getOrderExternalId(order as any);
    const shop = order.shop;

    if (platform === 'shopify' && shop?.name && externalId) {
      this.eCommerceOrderExternalLink = `https://${shop.name}/admin/orders/${externalId}`;
    } else if (platform === 'bigcommerce' && shop?.name && externalId) {
      this.eCommerceOrderExternalLink = `${shop.name}/manage/orders/${externalId}/`;
    } else {
      this.eCommerceOrderExternalLink = null;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.order = changes.order?.currentValue ?? this.order;
    this.orderSplitIndices = getOrderSplitIndicesString(this.order, 'view');
    this.generateExternalEcommerceOrderLink(this.order);
  }

  backToBatch() {
    this.fulfillService.setPanelState(PanelState.BATCH);
  }
}
